import { render, staticRenderFns } from "./TransferHierarchy.vue?vue&type=template&id=05dff44c&"
import script from "./TransferHierarchy.vue?vue&type=script&lang=js&"
export * from "./TransferHierarchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports